import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { searchService } from '../services/search.service';
import { SearchResult } from '../interfaces/search.interface';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-search',
  standalone: false,
  templateUrl: './search.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./search.component.scss']
})
export class SearchComponent {
  searchControl = new FormControl('');
  results: SearchResult[] = [];
  loading = false;
  imagesUrl = `${environment.ImagesUrl}/`;
  constructor(private searchService: searchService, private router: Router) { }

  onSearch(): void {
    const query = this.searchControl.value?.trim();
    if (!query) {
      this.results = [];
      localStorage.removeItem('searchText');
      return;
    }
    localStorage.setItem('searchText', query);
    this.loading = true;
    this.searchService.search(query).subscribe({
      next: (res: SearchResult[]) => {
        this.results = res;
        this.loading = false;
      },
      error: () => {
        this.results = [];
        this.loading = false;
      }
    });
  }

  ngOnInit(): void {
    const savedText = localStorage.getItem('searchText');
    if (savedText) {
      this.searchControl.setValue(savedText);
      this.onSearch();
    }
  }

  clearSearch(): void {
    this.searchControl.setValue('');
    this.results = [];
    localStorage.removeItem('searchText');
  }

  goToResult(result: SearchResult) {
    const safeName = result.name?.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'item';
    if (result.type === 'Offer') {
      this.router.navigate(['/oferta', safeName, result.id]);
    } else if (result.type === 'News') {
      this.router.navigate(['/wiadomosci', safeName, result.id]);
    } else if (result.type === 'Partner') {
      this.router.navigate(['/partner', safeName, result.id]);
    } else if (result.type === 'Page') {
      this.router.navigate(['/tresc/' + result.id, safeName]);
    }
  }
}